"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var ToolTip_1 = require("./ToolTip");
var clsx_1 = __importDefault(require("clsx"));
var BUTTON_STYLES = "rounded-full w-10 flex-shrink-0";
var PRIMARY_STYLES = "bg-sorbus-default text-white";
var HOVER_STYLES = "hover:bg-gray-400 hover:bg-opacity-25";
var PRIMARY_HOVER_STYLES = "hover:bg-sorbus-dark hover:text-white";
var INACTIVE_STYLES = "opacity-50";
var DISABLED_STYLES = "opacity-25 pointer-events-none";
var IconButton = function (_a) {
    var disabled = _a.disabled, icon = _a.icon, clickHandlerFromProps = _a.onClick, className = _a.className, style = _a.style, tooltip = _a.tooltip, _b = _a.tooltipAlignment, tooltipAlignment = _b === void 0 ? "center" : _b, _c = _a.toolTipDirection, toolTipDirection = _c === void 0 ? "below" : _c, inactive = _a.inactive, noPadding = _a.noPadding, primary = _a.primary;
    var _d = (0, react_1.useState)(), hoverTimeout = _d[0], setHoverTimeout = _d[1];
    var _e = (0, react_1.useState)(false), hover = _e[0], setHover = _e[1];
    var handleMouseOver = function (e) {
        if (tooltip) {
            setHoverTimeout(setTimeout(function () { return setHover(true); }, 500));
        }
    };
    var handleMouseOut = function (e) {
        if (tooltip) {
            clearTimeout(hoverTimeout);
            setHover(false);
        }
    };
    var handleClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (clickHandlerFromProps) {
            clickHandlerFromProps(e.currentTarget);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ className: (0, clsx_1.default)([
            BUTTON_STYLES,
            (className !== null && className !== void 0 ? className : "").indexOf("absolute") < 0 && "relative",
            (className !== null && className !== void 0 ? className : "").indexOf("hover:bg") < 0 && primary
                ? PRIMARY_HOVER_STYLES
                : HOVER_STYLES,
            primary && PRIMARY_STYLES,
            !noPadding && "p-2",
            className,
            disabled ? DISABLED_STYLES : inactive ? INACTIVE_STYLES : null,
        ]), onClick: handleClick, style: style, onMouseEnter: handleMouseOver, onMouseLeave: handleMouseOut }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon }, void 0), tooltip ? ((0, jsx_runtime_1.jsx)(ToolTip_1.ToolTip, { label: tooltip, active: hover, direction: toolTipDirection, align: tooltipAlignment }, void 0)) : null] }), void 0));
};
exports.IconButton = IconButton;
